import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import text from '../../../../text';
import routes from '../../../../routes/constants';

const Root = ({
  title,
  children,
  className,
  extraText,
}: {
  title: string;
  children: React.ReactNode;
  className: string;
  extraText: React.ReactNode;
}) => (
  <div className={classnames('Step', { [className]: className })}>
    {title ? (
      <div className='stepHeader'>
        {title ? <h4 className='stepTitle'>{title} </h4> : null}
        {extraText}
      </div>
    ) : null}
    {children}
    <p className='text-center'>
      {text('needHelpContactUs', {
        contactUs: (
          <Link
            key='urlTerms'
            to={{ pathname: routes.larkiWebsiteUrl.contactUs }}
            target='_blank'
          >
            {text('contactUs')}
          </Link>
        ),
      })}
    </p>
  </div>
);

const StepContent = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div className={classnames('StepContent', className)}>
    {children}
  </div>
);

export const Step = Object.assign(Root, { Content: StepContent });
